import React from 'react';

import { useStyles } from './styles';

export const VerticalTabs: React.FC = ({ children }) => {
  const classes = useStyles();
  return <ul className={classes.verticalTabs}>{children}</ul>;
};
